import React from "react";
import {
  Box,
  Button,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { useSnackbar } from "notistack";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";

import { CustomDialogTitle } from "../../ui";
import useCopyToClipboard from "../../hooks/useCopyToClipboard";
import { anchorSnackbarTop } from "../../constants";

function ShareProfile({ onClose, profileLink }) {
  const [_value, copy] = useCopyToClipboard();

  const { enqueueSnackbar } = useSnackbar();

  const handleCopy = (content: string, type: string) => {
    try {
      copy(content);
      enqueueSnackbar(`copied ${type} successfully`, {
        variant: "success",
        anchorOrigin: anchorSnackbarTop,
      });
    } catch (err) {
      console.error(err);
      enqueueSnackbar(`error copying ${type}`, {
        variant: "error",
        anchorOrigin: anchorSnackbarTop,
      });
    }
  };
  const onSocialMediaShare = (type, profileLink) => {
    // if(type=="twitter"){
    //     window.open(`https://twitter.com/share?url=${profileLink}`)!.focus();
    // }
    // else if(type == "facebook"){
    //     window.open(`https://www.facebook.com/sharer.php?u=${profileLink}`)!.focus();
    // }
    if (type == "whatsapp") {
      window.open(`https://wa.me/?text=${profileLink}`)!.focus();
    }
    // else if(type == "linkedIn"){
    //     window.open(`https://www.linkedin.com/share?url=${profileLink}`)!.focus();
    // }
    if (type == "email") {
      window
        .open(
          `mailto:?subject=here's%20my%20leap%20profile!&body=${profileLink}`
        )!
        .focus();
    }
  };
  return (
    <>
      <CustomDialogTitle onClose={onClose}>
        <Typography>share my profile</Typography>
      </CustomDialogTitle>
      <DialogContent>
        <Typography fontSize={12} mb={2} color="text.secondary">
          get the link or share on social
        </Typography>
        <Stack direction={{ xs: "column", lg: "row" }} spacing={2}>
          <Box
            minWidth="80%"
            sx={{
              display: "flex",
              flexDirection: "row",
              height: "3rem",
              alignItems: "center",
              paddingLeft: 1,
              fontWeight: 400,
              fontSize: "12px",
              border: 1,
              borderColor: grey[300],
              color: grey[600],
              borderRadius: 2,
              background: grey[50],
            }}
          >
            <Typography fontSize={12} color="text.secondary">
              {profileLink}
            </Typography>
          </Box>
          <Button
            variant="gradient"
            color="secondary"
            fullWidth
            sx={{ borderRadius: 2, fontSize: 12, py: 1 }}
            onClick={() => handleCopy(profileLink, "link")}
          >
            copy link
          </Button>
        </Stack>
        <Stack
          direction="row"
          sx={{ mt: "1rem" }}
          justifyContent={{ xs: "center", lg: "flex-start" }}
        >
          {/* <IconButton
              color="secondary"
              aria-label="send message"
              component="span"
              onClick={()=>onSocialMediaShare("twitter",profileLink)}
            >
              <TwitterIcon fontSize="large"/>
            </IconButton> */}
          {/* <IconButton
              color="secondary"
              aria-label="send message"
              component="span"
              onClick={()=>onSocialMediaShare("linkedIn",profileLink)}
            >
              <LinkedInIcon fontSize="large"/>
            </IconButton> */}
          {/* <IconButton
              color="secondary"
              aria-label="send message"
              component="span"
              onClick={()=>onSocialMediaShare("facebook",profileLink)}
            >
              <FacebookIcon fontSize="large"/>
            </IconButton> */}
          <IconButton
            color="secondary"
            aria-label="send message"
            component="span"
            onClick={() => onSocialMediaShare("whatsapp", profileLink)}
          >
            <WhatsAppIcon fontSize="large" />
          </IconButton>
          <IconButton
            color="secondary"
            aria-label="send message"
            component="span"
            onClick={() => onSocialMediaShare("email", profileLink)}
          >
            <EmailIcon fontSize="large" />
          </IconButton>
        </Stack>
      </DialogContent>
    </>
  );
}

export default ShareProfile;
